import { ReactNode, useState } from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface ShowMoreDialogProps {
  buttonText: string;
  buttonVariant: ButtonProps["variant"];
  buttonProps?: ButtonProps;
  children: ReactNode;
  title: string;
  noPadding?: boolean;
}
export const ShowMoreDialog = ({
  buttonText,
  buttonVariant = "outlined",
  buttonProps,
  children,
  title,
  noPadding,
  ...props
}: ShowMoreDialogProps & Omit<DialogProps, "onClose" | "open">) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <>
      <Button
        {...(buttonProps ?? {})}
        variant={buttonVariant}
        onClick={handleOpen}
      >
        {buttonText}
      </Button>
      <Dialog {...props} onClose={handleClose} open={open}>
        <DialogTitle sx={{ pr: 6 }}>
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {noPadding ? children : <DialogContent>{children}</DialogContent>}
      </Dialog>
    </>
  );
};
